import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {HttpUtilsService, QueryParamsModel} from '../../_base/crud';
import {environment} from '../../../../environments/environment';
import {CountryModel} from '../_models/country.model';
import { MadAuthService } from '../../mad-auth/mad-auth.service';
import { SubdomainService } from '../../_base/subdomain.service';


@Injectable()
export class CountryService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/countries`

    constructor(private http: HttpClient, private authService: MadAuthService, private httpUtils: HttpUtilsService, private subDomainService: SubdomainService) {
    }

    find(queryParams: QueryParamsModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

        return this.http.get<any>(this.API_URL, {
            headers: httpHeaders,
            params: httpParams
        });
    }

    getAllCountries(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get(this.API_URL, {headers: httpHeaders});
    }

    getAllCountriesMultimedia(): Observable<any> {
        return this.http.get(
            `${environment.baseApiUrl}api/${this.subDomainService.subDomain}/multimedia/countries`
        );
    }

    // DELETE => delete the Country from the server
    deleteCountry(countryId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        const url = `${this.API_URL}/${countryId}`;
        return this.http.delete(url, {headers: httpHeaders});
    }

    // CREATE =>  POST: add a new Country to the server
    createCountry(_country: CountryModel, _currency: any): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.post(this.API_URL, {country: _country, currency: _currency}, {headers: httpHeaders});
    }

    // UPDATE => PUT: update the Country on the server
    updateCountry(country: CountryModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.put(this.API_URL + `/${country.id}`, country, {headers: httpHeaders});
    }


    // TRASH (User)
    getTrashed(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash', {
            headers: httpHeaders
        });
    }

    // TRASH (Admin)
    getAdminTrashed(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get(this.API_URL + `/admin/trash`, {
            headers: httpHeaders
        });
    }

    deleteFromTrash(keyPlaceId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/trash/${keyPlaceId}`, {
            headers: httpHeaders
        });
    }

    // delete from admin trash
    deleteFromAdminTrash(keyPlaceId: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/admin/trash/${keyPlaceId}`, {
            headers: httpHeaders
        });
    }

    // restore from trash
    restoreFromTrash(id: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/trash/${id}`, {
            headers: httpHeaders
        });
    }

    flushTrash(): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + '/trash/flush', {
            headers: httpHeaders
        });
    }

    /*
     * Handle Http operation that failed.
     * Let the app continue.
    *
    * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
